import type { SVGProps } from "react";

export const Squareup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 396 396"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Squareup</title>
    <rect
      height="324"
      rx="30"
      ry="30"
      stroke="currentColor"
      strokeWidth="72"
      width="324"
      x="36"
      y="36"
    />
    <rect
      height="266"
      rx="28"
      ry="28"
      stroke="currentColor"
      strokeWidth="14"
      width="266"
      x="65"
      y="65"
    />
    <rect
      fill="currentColor"
      height="108"
      rx="12"
      ry="12"
      width="108"
      x="144"
      y="144"
    />
  </svg>
);

export default Squareup;
